"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownWrapper = exports.IconWrapper = exports.Label = exports.ActionButtonStyle = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
const ctaStyle = (0, styled_components_1.css) `
  background-color: ${colors_1.DARK_GREEN};
  color: ${colors_1.WHITE};
  border: 1px solid ${colors_1.DARK_GREEN};
  &:focus {
    opacity: 0.9;
  }
  &:hover {
    cursor: pointer;
    color: ${colors_1.WHITE};
    border: 1px solid ${colors_1.SWEGON_GREEN};
    background-color: ${colors_1.SWEGON_GREEN};
  }
`;
const panelStyle = (0, styled_components_1.css) `
  background-color: ${colors_1.LIGHT_GREY};
  color: ${colors_1.GREY4};
  border: none;
  &:focus {
    opacity: 0.9;
  }
  &:hover {
    cursor: pointer;
    border: none;
    color: ${colors_1.DARK_GREEN};
    background-color: ${colors_1.PALE_GREEN};
  }
`;
const hamburgerStyle = (0, styled_components_1.css) `
  height: 30px;
  overflow: hidden;
  padding: 6px 1px 1px;
  background-color: ${colors_1.LIGHT_GREY};
  color: ${colors_1.GREY4};
  border: none;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: ${colors_1.PALE_GREEN};
    border: 1px solid none;
  }
`;
exports.ActionButtonStyle = styled_components_1.default.div `
  padding: 4px;
  white-space: nowrap;
  outline: none;
  display: flex;
  align-items: center;
  height: 40px;
  width: max-content;
  font-weight: 400;
  font-family: SwegonBrown;
  ${({ $type }) => {
    switch ($type) {
        case "cta":
            return ctaStyle;
        case "hamburger":
            return hamburgerStyle;
        case "panel":
            return panelStyle;
    }
}}
  ${({ $active, $type }) => {
    if (!$active) {
        return;
    }
    switch ($type) {
        case "cta":
            return (0, styled_components_1.css) `
          background-color: ${colors_1.SWEGON_GREEN};
          border: 1px solid ${colors_1.SWEGON_GREEN};
        `;
        case "panel":
            return (0, styled_components_1.css) `
          background-color: ${colors_1.PALE_GREEN};
        `;
        case "hamburger":
    }
}};
`;
exports.Label = styled_components_1.default.label `
  font-size: 14px;
  line-height: 20px;
  margin-top: 3px;
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 496px) {
    display: none;
  }
`;
exports.IconWrapper = styled_components_1.default.div `
  ${({ $type }) => $type !== "hamburger" &&
    (0, styled_components_1.css) `
      padding-top: 7px;
      margin: 0 4px;
    `};
`;
exports.DropDownWrapper = styled_components_1.default.div `
  margin-left: 70px;
  ${({ $arrangement }) => $arrangement === "fitContent" &&
    (0, styled_components_1.css) `
      margin-left: 4px;
    `}
  display: flex;
  align-items: center;
  @media screen and (max-width: 496px) {
    margin-left: 0px;
  }
`;
//# sourceMappingURL=ActionButton.styles.js.map